import Database from './Database.vue';
export default Database;
